/** Homepage section ids, in page order. `register` is also a separate route. */
export const HOME_SECTION_IDS = [
  "home",
  "about",
  "events",
  "team",
  "gallery",
  "register",
  "contact",
];

/**
 * The current section is the one that has crossed the activation line and
 * sits closest to it. A tall earlier section still on screen loses to the
 * section you have scrolled into. Reaching the footer selects contact.
 */
export function activeSectionFromEntries(entries, { atPageEnd = false } = {}) {
  const visible = entries.filter((entry) => entry.isIntersecting && entry.target?.id);
  if (!visible.length) return null;
  if (atPageEnd) {
    const ids = new Set(visible.map((entry) => entry.target.id));
    for (let index = HOME_SECTION_IDS.length - 1; index >= 0; index -= 1) {
      if (ids.has(HOME_SECTION_IDS[index])) return HOME_SECTION_IDS[index];
    }
  }
  const bounds = visible.find((entry) => entry.rootBounds)?.rootBounds;
  const line = bounds ? bounds.top + Math.max(120, bounds.height * 0.4) : 160;
  const started = visible.filter((entry) => entry.boundingClientRect.top <= line);
  const pool = started.length ? started : visible;
  pool.sort((a, b) => b.boundingClientRect.top - a.boundingClientRect.top);
  return pool[0].target.id;
}
